import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import dynamic from 'next/dynamic';

import { useStore } from 'hooks/useStore';
import { IReactLoadsGridProps } from 'types/global';

type TPrettyLoadProps = Omit<IReactLoadsGridProps, 'siteFeatures' | 'culture'>;

// @ts-ignore
const LoadsGrid = dynamic(() => import('PrettyLoad/PrettyLoad'), {
  ssr: false,
});

const PrettyLoad = (props: TPrettyLoadProps) => {
  const { callbacks, descriptor, currentPage, loads, ...searchResult } = props;
  const { app, siteFeatures, enablerFeaturesRepo, ui } = useStore();

  const shouldSkipRenderPrettyLoad = typeof window === 'undefined' || !loads || !loads.length;
  if (shouldSkipRenderPrettyLoad) return null;

  return (
    <LoadsGrid
      {...searchResult}
      // @ts-ignore
      callbacks={callbacks}
      culture={app.locale}
      currentPage={currentPage}
      descriptor={descriptor}
      enabler={enablerFeaturesRepo.featuresByTitle}
      isPrintMode={ui.isPrintMode}
      loads={loads}
      setPrintMode={ui.setPrintMode}
      siteFeatures={toJS(siteFeatures.isSiteFeatureEnabled)}
      userId={window.atiUser.profile?.ati_code}
    />
  );
};

const connected = observer(PrettyLoad);

export { connected as PrettyLoad };
